import { useEffect } from "react";
import { useParams } from "react-router-dom";

/**
 * Short-URL forwarder: `/go/campaign/:id` → `/api/go/campaign/:id`.
 *
 * K8s ingress routes `/api/*` to the backend and everything else to the React app,
 * so we can't expose the tracker at a bare `/go/*` path directly. This component
 * captures `document.referrer` (from the ORIGINAL inbound source — email/social/etc)
 * and every UTM/aff query param, then replaces the location with the backend endpoint,
 * which does the actual click_event insert + 302 to the merchant site.
 *
 * We use `window.location.replace` so the intermediate `/go/campaign/:id` URL does
 * not pollute browser history — the shopper's back button goes to their previous page.
 */
export default function GoRedirect() {
  const { id } = useParams();
  useEffect(() => {
    if (!id) return;
    const backend = process.env.REACT_APP_BACKEND_URL || "";
    const src = new URLSearchParams(window.location.search);
    const forward = new URLSearchParams();
    for (const [k, v] of src.entries()) forward.set(k, v);
    // Preserve the ORIGINAL referrer (email client, twitter, google, etc). The backend
    // reads this hint when the HTTP Referer header points back at the Cyannect app.
    if (document.referrer && !forward.get("ref")) forward.set("ref", document.referrer);
    const target = `${backend}/api/go/campaign/${encodeURIComponent(id)}${forward.toString() ? `?${forward}` : ""}`;
    window.location.replace(target);
  }, [id]);
  return (
    <div className="min-h-screen flex items-center justify-center text-slate-500 text-sm" data-testid="go-redirect">
      Redirecting you securely…
    </div>
  );
}
